"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgInfoCircle(props) {
  return React.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    stroke: props.stroke,
    fill: props.fill
  }, props), React.createElement("path", {
    d: "M12 0c6.627 0 12 5.372 12 12 0 6.627-5.373 12-12 12-6.628 0-12-5.372-12-12S5.372 0 12 0zm0 1.532C6.218 1.532 1.532 6.218 1.532 12S6.218 22.468 12 22.468c5.78 0 10.468-4.687 10.468-10.468 0-5.782-4.687-10.468-10.468-10.468zm0 8.68c.388 0 .708.289.759.663l.007.104v7.149a.766.766 0 01-1.525.104l-.007-.104v-7.15c0-.422.343-.765.766-.765zm0-4.34a1.02 1.02 0 110 2.043 1.02 1.02 0 110-2.043z",
    fill: "inherit",
    fillRule: "evenodd"
  }));
}

var _default = SvgInfoCircle;
exports.default = _default;